import Cookies from 'js-cookie'

const nvModal = {
  el: document.getElementById('nv-modal'),
  cookieName() {
    return `nv.modal.${nvModalConfig.cookieName}`;
  },
  close() {
    nvModal.el.close();
  },
  handleOnLoad() {
    const cookieExist = !!Cookies.get(nvModal.cookieName());
    if (cookieExist) {
      return;
    }

    const cookieConfig = {
      expires: parseInt(nvModalConfig.cookieExpiration),
      SameSite: 'Strict'
    };
    Cookies.set(nvModal.cookieName(), 1, cookieConfig);

    nvModal.el.showModal();
    nvModal.el.addEventListener('close', nvModal.close);
    nvModal.el.querySelector('.nv-modal-close-button').addEventListener('click', nvModal.close);
  },
};

document.addEventListener('DOMContentLoaded', nvModal.handleOnLoad);
document.addEventListener('nv.modal.close', nvModal.close);
